export default "__VITE_ASSET__GoUb24wt__"